import _ from 'underscore';
import Backbone from 'backbone';
import React from 'react';
import { createRoot } from 'react-dom/client';
import Loadable from 'utils/extensions/Loadable';
import ViewUserPreferences from 'models/user/ViewerUserPreferences';
import ReactDefaultProps from 'views/main/react/ReactDefaultProps';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'config/queryClient';

var ReactComponentPageView = Backbone.View.extend(Loadable).extend({
    initialize: function(args) {
        if (!args.page) {
            throw 'ReactComponentPageView: page property is required';
        }

        this.page = args.page;
        this.args = _.omit(args, 'page');
    },

    render: function() {
        this.setupSigninUrl();
        this.element = $('.content')[0];

        var component = this.component();

        this.root = createRoot(this.element);
        this.root.render(component);
        return this;
    },

    component: function() {
        var args = $.extend(true, {}, this.args, ReactDefaultProps, {
            rootElement: this.element,
            preferredLocale: ViewUserPreferences.getLocale()
        });

        // Wrap the page child element in a QueryCientProvider
        return React.createElement(QueryClientProvider, { client: queryClient }, React.createElement(this.page, args));
    },

    getSystemMessage: function() {
        return null;
    },

    getSuccessMessage: function() {
        return null;
    },

    getFailureMessage: function() {
        return null;
    },

    getInfoMessage: function() {
        return null;
    },

    /**
     * Place to put cleanup code. Called when page is unloaded.
     */
    onPageUnloaded: function() {
        this.root.unmount(this.element);
    },

    setupSigninUrl: function() {
        if (ViewUserPreferences.viewerIsAuthenticated) {
            return;
        }
        // redirect user to current page after signin
        jQuery('.nav-signin-container .nav-signin').attr('href', this.getSigninUrl(window.location.href));
    },

    getSigninUrl: function(url) {
        return window.location.origin + '/modern/auth/logout/?url=' + url;
    }
});

export default ReactComponentPageView;
